import LocaleSelector from './LocaleSelector';

export default LocaleSelector;
